export const FEEDBACK_ROTATION_INTERVAL = 5000;
